import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const credentials = process.env.REACT_APP_BASIC_AUTH;

const rawBaseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_PUBLIC_URL}/`,
  // prepareHeaders: (headers) => {
  //   headers.set("Authorization", `Basic ${credentials}`);
  //   return headers;
  // },
});

const baseQueryWithRetry = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error?.status === 403) {
    return await rawBaseQuery(args, api, extraOptions);
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithRetry,
  endpoints: (builder) => ({
    getProtectedApiData: builder.query({
      query: ({ url, lang }) => `${lang}/api/v1/${url}`,
    }),
    getProtectedApiHtml: builder.query({
      query: ({ url, lang }) => `${lang}/node/${url}?_format=json`,
    }),
    getProtected: builder.query({
      query: (url) => `${url}`,
    }),
    // tender-> prebid clarification
    getClarification: builder.query({
      query: ({ languageType }) =>
        languageType
          ? `/api/tenders/${languageType}/searchpage3`
          : "/api/tenders/searchpage3",
    }),
    // tenders-> archived tenders
    getArchivedTenderApi: builder.query({
      query: ({ page, title, language }) =>
        language
          ? `api/v1/${language}/tendersarchive?page=${page}&title=${title}`
          : `api/v1/tendersarchive?page=${page}&title=${title}`,
    }),
  }),
});

export const {
  useGetProtectedApiDataQuery,
  useGetProtectedApiHtmlQuery,
  useGetProtectedQuery,
  useGetClarificationQuery,
  useGetArchivedTenderApiQuery,
} = apiSlice;
